import LanguageDropdown from "components/Language/LanguageDropdown"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Menu, Modal, Button } from "semantic-ui-react"
import { Row, Col, Form, FormField, FormInput } from "elemental-react16"
import { withRouter } from "react-router"
import queryString from "qs"
import "pages/Login.css"
import shop from "shop/shop"
import WordPressContainer from "WordPressContainer"
import config from "config"


@withRouter
export default class LoginPage extends Component {
  constructor() {
    super()
    this.state = {
      user    : "",
      password: ""
    }
    shop.whoami()
  }
  
  handleLogin = ( e ) => {
    const { history } = this.props
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    console.log( { query } )
    const { referrer } = query
    shop.login( { ...this.state } )
      .catch( ( err ) => {
        console.error( err )
        shop.toast( translate( "Fehler bei der Anmeldung" ), "error" )
        return false
      } )
      .then( session => {
        if ( !session ) return
        shop.loadCategories()
        shop.cart.hydrate()
        shop.toast( `${translate("Willkommen")} ${session.value.title ? session.value.title : ""}` )
        let redirectTo = referrer || shop.locationAfterLogin
        console.log( "AFTER", redirectTo )
        if ( redirectTo ) {
          history.push( redirectTo )
        } else {
          history.push( "/home" )
        }
      } )
    
    e.preventDefault()
  }
  
  handleUserChange = ( event ) => {
    this.setState( {
      user: event.target.value
    } )
  }
  
  handlePasswordChange = ( event ) => {
    this.setState( {
      password: event.target.value
    } )
  }
  
  render() {
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    return (
      <div className="LoginPage pb6">
        <div className=" container">
          <div className="black absolute top-0 right-2 pt2">
            <LanguageDropdown/>
          </div>
          
          <section>
            <Row>
              <Col className="text-center pb4"
                   style={{ marginTop: "60px" }}>
                <Link className={"logo"} to="/home/">
                  <img
                    width={360}
                    src={shop.config.logo}
                    alt=""/>
                </Link>
              </Col>
            </Row>
          </section>
          
          <WordPressContainer postType={"shop"} slug={"login"}/>
          
          
          <div className="flex flex-column flex-row-ns justify-between-ns mw8 ph4-ns center">
            <div className="pb4 pb0-ns ph4-ns w-100">
              <h2 className={"text-primary tc b"}>{translate("Kunden")}</h2>
              <Form onSubmit={this.handleLogin}>
                <div>
                  <div>
                    <FormField label={translate( "Benutzer" )}
                               htmlFor="basic-form-input-email">
                      <FormInput value={this.state.user}
                                 onChange={this.handleUserChange}
                                 type="text"
                                 placeholder={translate( "Benutzer" )}
                                 name="basic-form-input-id"/>
                    </FormField>
                    <FormField label={translate( "Passwort" )}
                               htmlFor="basic-form-input-password">
                      <FormInput value={this.state.password}
                                 onChange={this.handlePasswordChange}
                                 type="password"
                                 placeholder={translate( "Passwort" )}
                                 name="basic-form-input-password"/>
                    </FormField>
                  </div>
                  
                  <div className="tc pt3  ">
                    <Button
                      primary
                      submit
                    >{translate( "Anmelden" )}</Button>
                    <Link className="db mt3 black-70"
                          to="/reset_password">{translate( "Passwort vergessen" )}</Link>
                  </div>
                </div>
                {/*<FormField>*/}
                {/*<Checkbox label="Login speichern" />*/}
                {/*</FormField>*/}
              
              </Form>
            </div>
            
            <div className="w-100 ph4-ns  ">
              <h2 className={"text-primary tc b"}>{translate("Neukunden")}</h2>
              <div className="tc flex flex-column  justify-between ">
                <div className="f4 tc pb3 lh-copy pt3">{translate( "No account yet?" )}</div>
                
                <div className="mt-auto ">
                  <Button primary as={Link} to="/customer_registration">{translate( "Neu registrieren" )}</Button>
                  {config.customer_enabling &&
                  <div><Link to="/customer_enabling">{translate( "access with offline account" )}</Link></div>}
                </div>
              
              </div>
            </div>
          
          </div>
          
          {config.b2cLink && <div>
            <hr/>
            <div className="tc">
              <a href={config.b2cLink}>{translate( "B2C Shop" )}</a>
            </div>
          </div>}
        </div>
        
        <div className="bg-silver fixed bottom-0 left-0 right-0">
          
          <Menu fluid
                secondary
                size="small">
            <Menu.Item as={Link} to={{ pathname: "/login/", search: queryString.stringify( { ...query, modal: "data" } ) }}
                       position="right">{translate( "Data Policy" )}</Menu.Item>
            <Menu.Item as={Link} to={{ pathname: "/login/", search: queryString.stringify( { ...query, modal: "imprint" } ) }}>{translate( "imprint" )}</Menu.Item>
            <Menu.Item as={Link} to={{ pathname: "/login/", search: queryString.stringify( { ...query, modal: "agb" } ) }}>AGB</Menu.Item>
          </Menu>
        
        </div>
        
        
        <Modal
          open={query.modal && query.slug}
          closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"}/>}>
          <Modal.Content>
            <WordPressContainer postType="page"
                                slug={query.slug}/>
          </Modal.Content>
        </Modal>
        
        <Modal
          open={query.modal === "data"}
          closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"}/>}>
          <Modal.Content>
            <WordPressContainer postType="page"
                                slug="datenschutz"/>
          </Modal.Content>
        </Modal>
        
        <Modal
          open={query.modal === "imprint"}
          closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"}/>}>
          <Modal.Content>
            <WordPressContainer postType="page"
                                slug="impressum"/>
          </Modal.Content>
        </Modal>
        
        <Modal
          open={query.modal === "agb"}
          closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"}/>}>
          <Modal.Content>
            <WordPressContainer postType="page"
                                slug="agb"/>
          </Modal.Content>
        </Modal>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/theme/fiebiger/pages/LoginPage.js